var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "IconButtonWrapper",
    _vm._b(
      { staticClass: "color-picker-button" },
      "IconButtonWrapper",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "svg",
        {
          attrs: {
            width: "100%",
            height: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 62 68",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M31 66.1C14.2 66.1.5 52 .5 34.8.5 17.5 14.1 3.5 31 3.5s30.5 14.1 30.5 31.3c0 17.3-13.7 31.3-30.5 31.3zm0-59.6C15.8 6.5 3.5 19.2 3.5 34.8S15.8 63.1 31 63.1s27.5-12.7 27.5-28.3S46.1 6.5 31 6.5z",
              opacity: ".25",
            },
          }),
          _c("path", {
            attrs: {
              d: "M31 63.5C14.2 63.5.5 49.4.5 32.2.5 14.9 14.1.9 31 .9S61.5 15 61.5 32.2c0 17.3-13.7 31.3-30.5 31.3zm0-59.6C15.8 3.9 3.5 16.6 3.5 32.2S15.8 60.5 31 60.5s27.5-12.7 27.5-28.3S46.1 3.9 31 3.9z",
            },
          }),
          _c("path", {
            attrs: {
              d: "M59.2,38.5c-1.3,5-4,9.6-7.7,13.2l-6.1-6.2c2.6-2.6,4.4-5.7,5.4-9.2L59.2,38.5z",
              fill: "#006fc4",
            },
          }),
          _c("path", {
            attrs: {
              d: "M51.7 51.6c-3.7 3.7-8.2 6.3-13.2 7.6l-2.2-8.5c3.5-.9 6.7-2.7 9.3-5.3l6.1 6.2z",
              fill: "#3a48ba",
            },
          }),
          _c("path", {
            attrs: {
              d: "M38.6,59.2c-5,1.3-10.3,1.3-15.3,0l2.3-8.4c3.5,0.9,7.2,0.9,10.7,0L38.6,59.2z",
              fill: "#7421b0",
            },
          }),
          _c("path", {
            attrs: {
              d: "M23.4,59.2c-5-1.3-9.6-4-13.2-7.7l6.2-6.2c2.6,2.6,5.7,4.4,9.2,5.4L23.4,59.2z",
              fill: "#d2298e",
            },
          }),
          _c("path", {
            attrs: {
              d: "M10.3 51.6C6.7 47.9 4 43.4 2.7 38.4l8.5-2.2c.9 3.5 2.7 6.7 5.3 9.3l-6.2 6.1z",
              fill: "#ff2600",
            },
          }),
          _c("path", {
            attrs: {
              d: "M23.4,2.6c5-1.3,10.3-1.3,15.3,0l-2.3,8.5c-3.5-0.9-7.2-0.9-10.7,0L23.4,2.6z",
              fill: "#feef00",
            },
          }),
          _c("path", {
            attrs: {
              d: "M38.6,2.6c5,1.3,9.6,4,13.2,7.7l-6.2,6.2c-2.6-2.6-5.7-4.4-9.2-5.4L38.6,2.6z",
              fill: "#7fd200",
            },
          }),
          _c("path", {
            attrs: {
              d: "M51.7 10.2c3.7 3.7 6.3 8.2 7.6 13.2l-8.4 2.2c-.9-3.5-2.8-6.7-5.4-9.3l6.2-6.1z",
              fill: "#00b500",
            },
          }),
          _c("path", {
            attrs: {
              d: "M59.2 23.3a30.5 30.5 0 0 1 0 15.3l-8.4-2.3c.9-3.5 1-7.2 0-10.7l8.4-2.3z",
              fill: "#00c2af",
            },
          }),
          _c("path", {
            attrs: {
              d: "M2.8,38.5c-1.3-5-1.3-10.3,0-15.3l8.5,2.3c-0.9,3.5-0.9,7.2,0,10.7L2.8,38.5z",
              fill: "#fb6312",
            },
          }),
          _c("path", {
            attrs: {
              d: "M2.7,23.3c1.3-5,4-9.6,7.6-13.2l6.2,6.2c-2.6,2.6-4.4,5.7-5.4,9.2L2.7,23.3z",
              fill: "#f69f23",
            },
          }),
          _c("path", {
            attrs: {
              d: "M10.3 10.2c3.7-3.7 8.2-6.3 13.2-7.6l2.2 8.5c-3.5.9-6.7 2.7-9.3 5.3l-6.1-6.2z",
              fill: "#fac712",
            },
          }),
          _c("path", {
            attrs: {
              d: "M31 51.6c-11.4 0-20.7-9.3-20.7-20.7S19.6 10.2 31 10.2s20.7 9.3 20.7 20.7S42.4 51.6 31 51.6zm0-39.9c-10.6 0-19.2 8.6-19.2 19.2S20.4 50.1 31 50.1s19.2-8.6 19.2-19.2S41.6 11.7 31 11.7zm0 49.8C14.2 61.5.4 47.8.4 30.9.4 14.1 14.1.3 31 .3 47.8.3 61.6 14 61.6 30.9 61.5 47.7 47.8 61.5 31 61.5zm0-59.7c-16 0-29.1 13-29.1 29.1C1.9 46.9 15 60 31 60s29-13.1 29-29.1S47 1.8 31 1.8z",
            },
          }),
          _c("path", {
            attrs: {
              d: "M38.6 34.4c0-5.1-6.8-13.5-7.1-13.8L31 20l-.5.6c-.3.4-7.1 8.8-7.1 13.8v.5c0 3.9 3.4 7.1 7.6 7.1s7.6-3.2 7.6-7.1v-.5z",
              fill: "#030100",
            },
          }),
          _c("path", {
            attrs: {
              d: "M37.7 34.2c0 3.4-3 6.2-6.7 6.2s-6.7-2.8-6.7-6.2c0-4.8 6.7-13 6.7-13s6.7 8.3 6.7 13z",
              fill: _vm.color,
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }